import cn from 'classnames'
import React from 'react'

import { Tooltip } from 'components/uiKit/Dropdown'
import Icon from 'components/uiKit/Icon'
import type { IMenuOption } from 'components/uiKit/Menu'
import { testProps } from 'utils/test/qaData'

import * as s from './ControlItem.module.scss'

type ControlItemProps<V extends string> = {
  handler: ({ value }: { value: V }) => void
  option: IMenuOption<V>
  active?: boolean
  children?: React.ReactNode
}

const ControlItem = <V extends string>({
  handler,
  option,
  active,
  children,
}: ControlItemProps<V>) => {
  if (!children && !option.icon) {
    throw new Error('ControlItem: icon is required when children is not provided')
  }

  if (typeof option.label === 'function') {
    throw new Error('ControlItem: label must be a string')
  }

  const content = children ?? <Icon name={option.icon!} aria-hidden />

  if (children) {
    return (
      <div
        {...testProps({ el: 'layoutAction', name: option.value })}
        onClick={option.disabled ? undefined : () => handler({ value: option.value })}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {content}
      </div>
    )
  }

  return (
    <Tooltip overlay={option.label}>
      <div
        {...testProps({ el: 'layoutAction', name: option.value })}
        className={cn(s.root, { [s.active]: active, [s.disabled]: option.disabled })}
        onClick={option.disabled ? undefined : () => handler({ value: option.value })}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {content}
      </div>
    </Tooltip>
  )
}

export default ControlItem
